export default __webpack_public_path__ + "static/media/greenpizza@3x.dd18704c.jpg";